function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";

var SvgMaximize = function SvgMaximize(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Maximize' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 48 48"
  }), React.createElement("polygon", {
    points: "1.9998 36.5764 1.9998 24.9994 -0.0002 24.9994 -0.0002 40.0004 15.0008 40.0004 15.0008 38.0004 2.9178 38.0004 16.3348 24.7024 15.0458 23.2834"
  }), React.createElement("polygon", {
    points: "25.0002 0.0004 25.0002 2.0004 36.0902 2.0004 22.7972 15.2884 24.4592 16.7004 38.0002 3.4054 38.0002 14.9994 39.9992 14.9994 39.9992 0.0004"
  }));
};

SvgMaximize = pure(SvgMaximize);
SvgMaximize.displayName = 'SvgMaximize';
export default SvgMaximize;